import { Layer } from './layer';

import Vector from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';

class VectorLayer extends Layer {
	
	constructor(source, layer) {
		super(layer);
		this.source = source;
	}
	
	addFeature(feature) {
        this.removeFeature(feature);
        
		if( feature != null ) {
			this.source.addFeature(feature);        	
		} else {
			console.log("null feature");
		}        
	}
	
	addFeatures(features) {
		if( features.length > 0 ) {
        	this.source.addFeatures(features);
        }
	}
	
	removeFeature(feature) {
		if( this.hasFeature(feature) ) {
			this.source.removeFeature(feature);		
		}
	}
	
	hasFeature(feature) {
		return feature && this.source.hasFeature(feature);
	}
	
	getFeatures() {
		return this.source.getFeatures();
	}
	
	getFeaturesAtCoordinate(coordinate) {
		return this.source.getFeaturesAtCoordinate(coordinate);
	}
	
	clear() {
		this.source.clear();
	}
	
}

const vector = (style) => {
	const source = new VectorSource();
	
	const layer = new Vector({
		source: source,
		style: style
	});
	
	return new VectorLayer(source, layer);


}

export { vector, VectorLayer }